<template>
<div class="focused-panel">
  <div class="d-flex polytron-toolbar">
    <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select polygon" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete poly" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>
  </div>

  <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm" :title="formTitle" @ok="onOK" @cancel="onCancel">
    <div slot="modal-header">
      <label>{{formTitle}}</label>
    </div>
    <div class="p-2">
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="Ident:">
              <b-form-input id="batch_name" v-model="wellAttrs['ident']" placeholder="Enter sub surface polygon ident"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </b-modal>

</div>
</template>

<script>
import 'vue-awesome/icons/arrows-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/check'
import Vue from 'vue'

import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import uuidV1 from 'uuid/v1'

export default {
  name: 'sub-surface-polgyon-v4',
  components: {

  },
  mixins: [FeatureEditorMixin],
  data() {
    return {
      markLastModified: false,
      featureId: null,
      addPolyEnabled: false,
      addLineEnabled: false,
      addPointEnabled: false,
      wellAttrs: {
        ident: ''
      },
      options: [],
      causes: [],
      wellLayerName: 'v4:sub_surface_planning_polygons_v4',
      geometryName: 'geo',
      idName: 'id',
      geomType: 'Polygon',
      identName: 'ident',
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/SubSurfacePolyEditorV4.vue